<div class="prefix-group-dialog">
  <form #prefixForm="ngForm" autocomplete="off">

    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="prefixGroup.name" matInput name="name" required maxlength="255">
    </mat-form-field>

    <ac-input-container label="Type">
      <ac-select [acModel]="prefixGroup.type"
                 [searchable]="false"
                 (acModelChange)="prefixGroup.type = $event;"
                 [items]="prefixTypeOptions"
                 [ngDisabled]="isEditMode"
                 alternativeName="prefixGroup.type"
                 bindLabel="text"
                 bindValue="value">
      </ac-select>
    </ac-input-container>

    <div class="prefixes-and-warning-container">
      <mat-form-field name="prefixGroup-values" class="prefix-group-values" required>
        <mat-chip-list #chipList required>
          <mat-chip
            *ngFor="let chip of prefixGroup.values | prefixesSearchFilter: searchValue"
            [selectable]="true"
            [removable]="true"
            (removed)="removePrefixValue(chip)">
            <div class="chip-text" title="{{chip}}">{{chip}}</div>
            <mat-icon matChipRemove class="material-icons">cancel</mat-icon>
          </mat-chip>
          <input [placeholder]="'Click to add a ' + (prefixGroup.type === 'PREFIX' ? 'prefix' : 'number')"
                 [matChipInputFor]="chipList"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 [matChipInputAddOnBlur]="true"
                 (paste)="paste($event)"
                 (matChipInputTokenEnd)="addPrefixValue($event)">
        </mat-chip-list>
      </mat-form-field>

      <i class="fa fa-times clear-prefixes"
         title="Clear all prefixes"
         (click)="clearPrefixes()"
         *ngIf="prefixGroup.values && prefixGroup.values.length > 0">
      </i>
    </div>

    <div class="limitWarningContainer">
      <label class="limitWarning">Showing {{(prefixGroup.values | prefixesSearchFilter: searchValue)?.length}}
        {{prefixGroup.type === 'PREFIX' ? 'prefixes' : 'numbers'}} from a total of
        {{(prefixGroup.values | totalPrefixesSearchFilter: searchValue)}}</label>
    </div>

    <div class="prefix-group-search">
      <mat-form-field appearance="standard" class="prefix-search">
        <mat-label>Search for a {{prefixGroup.type === 'PREFIX' ? 'prefix' : 'number'}}</mat-label>
        <mat-icon matPrefix class="material-icons">search</mat-icon>
        <input matInput [(ngModel)]="model" (ngModelChange)="searchChanged($event)"
               [ngModelOptions]="{standalone: true}">
        <mat-icon matSuffix class="material-icons clear-search-icon" (click)="clearSearch()" *ngIf="searchValue">close
        </mat-icon>
      </mat-form-field>

      <div>
        <mat-label class="copy-to-clipboard" #tooltip="matTooltip"
                   (click)="copyPrefixesToClipboard()"
                   (mouseleave)="setDefaultCopyToClipboardTooltip()"
                   [matTooltip]="copyToClipboardTooltipContent">Copy to clipboard
        </mat-label>
      </div>

      <!--  <span class="copy-prefixes-to-clipboard" [matTooltip]="copyToClipboardTooltipContent" (click)="$event.stopImmediatePropagation()">
              <a ngxClipboard
                 [cbContent]="copyPrefixesToClipboard()"
                 (cbOnSuccess) = "copyToClipboardTooltipContent = 'Copied'"
                 (mouseleave)="setDefaultCopyToClipboardTooltip()"
                 class="copy-to-clipboard">
                  Copy to clipboard
              </a>
          </span>-->
    </div>

  </form>
</div>
